import CenterDCBReportActionTypes from './center-DCB-report.types';

export const fetchCenterDCBReportStart = (getData: any) => ({
	type: CenterDCBReportActionTypes.FETCH_CENTER_DCB_REPORT_START,
	payload: getData,
});

export const fetchCenterDCBReportSuccess = (success: any) => ({
	type: CenterDCBReportActionTypes.FETCH_CENTER_DCB_REPORT_SUCCESS,
	payload: success,
});

export const fetchCenterDCBReportFailure = (failure: any) => ({
	type: CenterDCBReportActionTypes.FETCH_CENTER_DCB_REPORT_FAILURE,
	payload: failure,
});

export const fetchCenterDCBReportResponseResetStart = () => ({
	type: CenterDCBReportActionTypes.FETCH_CENTER_DCB_REPORT_RESPONSE_RESET,
});

export const fetchCenterDCBReportResponseChanged = () => ({
	type: CenterDCBReportActionTypes.FETCH_CENTER_DCB_REPORT_RESPONSE_CHANGED,
});
